export class VersaoSemanticaUtils {
  static validarVersaoMinima(versaoMinima: string, versaoRecebida: string): boolean {
    const versaoRecebidaNumeros = this.extrairNumerosDaVersao(versaoRecebida);
    const versaoMinimaNumeros = this.extrairNumerosDaVersao(versaoMinima);

    const minimoComparacao = Math.min(versaoRecebidaNumeros.length, versaoMinimaNumeros.length);

    for (let i = 0; i < minimoComparacao; i++) {
      const numeroRecebido = versaoRecebidaNumeros[i] || 0;
      const numeroMinimo = versaoMinimaNumeros[i] || 0;

      if (numeroRecebido !== numeroMinimo) {
        return numeroRecebido > numeroMinimo;
      }
    }

    if (versaoRecebidaNumeros.length > 3 && versaoMinimaNumeros.length === 3) {
      return false;
    }

    const sufixoRecebido = versaoRecebida.match(/[^0-9]+/);
    const sufixoMinimo = versaoMinima.match(/[^0-9]+/);

    if (!sufixoRecebido && sufixoMinimo) {
      return false;
    }

    if (sufixoRecebido && sufixoMinimo) {
      return sufixoRecebido[0].localeCompare(sufixoMinimo[0], undefined, { numeric: true }) >= 0;
    }

    return true;
  }

  static extrairNumerosDaVersao(versao: string): number[] {
    const numerosStr = versao.match(/\d+/g);
    return numerosStr ? numerosStr.map(numeroStr => parseInt(numeroStr, 10)) : [];
  }
}
